import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from '../index';
import { IUpdatePricingCategoryProductsRequest, IUpdatePricingCategoryProductsResponse } from './types';

export const updatePricingCategoryProducts = async (
  priceSchemeId: string,
  categoryId: string,
  requestBody: IUpdatePricingCategoryProductsRequest,
): Promise<IUpdatePricingCategoryProductsResponse> => {
  try {
    const body = JSON.stringify(requestBody);

    const response = await fetch(`${API_URL}/pricing/schemes/${priceSchemeId}/categories/${categoryId}/items`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    if (!response.ok) {
      throw new Error('Failed to update pricing category products: response not ok');
    }

    return await response.json();
  } catch {
    throw new Error('Error updating pricing category products');
  }
};
